document.addEventListener('DOMContentLoaded', function () {
    // Mobile Nav
    const mobileMenu = document.querySelector('#mobile-menu');
    const openMenuButton = document.querySelector('#open-menu');
    const closeMenuButton = document.querySelector('#close-nav');

    openMenuButton.addEventListener('click', toggleMobileMenu);
    closeMenuButton.addEventListener('click', toggleMobileMenu);

    function toggleMobileMenu(e) {
        e.preventDefault();
        mobileMenu.classList.toggle('tw-hidden');
        console.log(mobileMenu.classList.contains('tw-hidden') ? 'Closing menu' : 'Open menu');
    }

    var header = document.querySelector('header');

    // Functie om header-stijl te wijzigen bij scrollen
    function handleScroll() {
        var scrollPosition = window.scrollY;
        if (scrollPosition > 0) {
            header.classList.add('scrolled');
        } else {
            header.classList.remove('scrolled');
        }
    }

    // Voeg scroll-eventlistener toe
    window.addEventListener('scroll', handleScroll);

    // Collapse tweede ul-element als het bestaat
    const secondUl = document.querySelector('#mobile-menu ul:nth-of-type(2)');
    if (secondUl) {
        const secondUlLinks = secondUl.querySelectorAll('li');
        // Verberg tweede ul-element en wijzig de icoon
        secondUlLinks.forEach(function(link) {
            link.addEventListener('click', function() {
                const childUl = link.querySelector('ul');
                if (childUl) {
                    childUl.classList.toggle('tw-block');
                    const chevronIcon = link.querySelector('i');
                    chevronIcon.classList.toggle('fa-chevron-down');
                    chevronIcon.classList.toggle('fa-chevron-up');
                }
            });
        });
    }
});
